/*
 * /slavic-stress page — live stress marks for Ukrainian and Belarusian.
 *
 * The page never waits for a button: the result pane follows the text box as
 * the person types (debounced), because the whole job is a dictionary lookup
 * that takes milliseconds once the dictionary is in memory. Everything heavy —
 * fetching and parsing the dictionary, analysing text — runs in
 * js/slavic-accent/worker.js; if a worker cannot start, the same core runs here.
 *
 * Corrections go INTO the text box as the person's own marks (U+0301), not into
 * a hidden override table: the core treats a typed mark as law, the mark
 * survives copy/paste and further editing, and Ctrl+Z undoes it.
 *
 * Documents (.docx/.odt) are marked inside the file (js/slavic-accent/doc.js) and
 * are the unit of the daily cap; typing and plain-text files are not capped.
 */
(function () {
    'use strict';
    var CFG = window.__SS_CFG;
    var C = window.SlavicAccentCore;
    if (!CFG || !C) return;

    var I = CFG.i18n || {};
    function t(k, rep) {
        var s = I[k] || '';
        if (rep) Object.keys(rep).forEach(function (r) { s = s.split(':' + r).join(rep[r]); });
        return s;
    }
    function $(id) { return document.getElementById(id); }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function fmtNum(n) { try { return new Intl.NumberFormat(CFG.locale).format(n); } catch (e) { return String(n); } }
    function ae(name, data) { try { if (window.__ae) window.__ae(name, Object.assign({ slug: CFG.slug }, data || {})); } catch (e) {} }
    function feature(f, data) { ae('feature_use', Object.assign({ f: f }, data || {})); }
    function save(k, v) { try { if (window.__toolSettings) window.__toolSettings.save(CFG.slug, k, v); } catch (e) {} }
    function load(k, d) { try { return window.__toolSettings ? window.__toolSettings.load(CFG.slug, k, d) : d; } catch (e) { return d; } }

    var root = $('ss'), input = $('ssInput'), out = $('ssOut'), note = $('ssNote');
    var card = $('ssCard');
    var SUFFIX = { uk: 'наголоси', be: 'націскі' };
    var LANG_NAME = { uk: 'Українська', be: 'Беларуская' };
    var RENDER_WORDS = 40000;
    // The Slavic text is LTR; interface sentences inside the result pane follow the page.
    var PAGE_DIR = document.documentElement.getAttribute('dir') === 'rtl' ? 'rtl' : 'ltr';

    var state = {
        lang: load('lang', 'uk') === 'be' ? 'be' : 'uk',
        langLocked: false,
        fmt: load('fmt', 'acute'),
        opts: { guesses: load('guesses', true) !== false, mono: !!load('mono', false), onlyAmbiguous: !!load('onlyHomo', false) },
        view: 'result',
        tokens: [], text: '', tokLang: null,
        seq: 0, quiz: null, quizSrc: 'text', deck: null, deckSeq: 0, cardIdx: -1, flashAt: -1,
        file: null, lastDoc: null, firstResult: false
    };
    if (['acute', 'plus', 'plusafter', 'caps'].indexOf(state.fmt) < 0) state.fmt = 'acute';

    /* ── engine: worker first, the same core on this thread as a fallback ──── */

    var engine = (function () {
        var w = null, pending = {}, seq = 0, readyP = {}, readyRes = {}, onMsg = null, mainDicts = {}, useMain = false;
        function fail(lang, msg) {
            if (readyRes[lang]) { readyRes[lang].rej(new Error(msg)); delete readyP[lang]; delete readyRes[lang]; }
            if (onMsg) onMsg({ type: 'error', lang: lang, message: msg });
        }
        function handle(m) {
            if (m.id && pending[m.id]) {
                var p = pending[m.id]; delete pending[m.id];
                if (m.type === 'error') p.rej(new Error(m.message)); else p.res(m);
                return;
            }
            if (m.type === 'ready' && readyRes[m.lang]) { readyRes[m.lang].res(m); delete readyRes[m.lang]; }
            if (m.type === 'error' && m.lang) { fail(m.lang, m.message); return; }
            if (m.type === 'error' && !m.lang) { toMain('worker_' + m.message); return; }
            if (onMsg) onMsg(m);
        }
        function start() {
            if (typeof Worker === 'undefined') { useMain = true; return; }
            try { w = new Worker(CFG.workerUrl); }
            catch (e) { useMain = true; feature('worker_fail', { why: 'ctor' }); return; }
            w.onmessage = function (ev) { handle(ev.data || {}); };
            w.onerror = function (ev) { if (ev && ev.preventDefault) ev.preventDefault(); toMain('worker_error'); };
        }
        // A worker that failed mid-flight: re-issue its loads here.
        function toMain(why) {
            if (useMain) return;
            useMain = true;
            feature('worker_fail', { why: String(why).slice(0, 60) });
            try { if (w) w.terminate(); } catch (e) {}
            w = null;
            Object.keys(pending).forEach(function (id) { pending[id].rej(new Error('worker_gone')); delete pending[id]; });
            Object.keys(readyRes).forEach(function (lang) { mainLoad(lang); });
        }
        async function mainLoad(lang) {
            try {
                var d = CFG.dict[lang], t0 = Date.now();
                var r = await fetch(d.url);
                if (!r.ok) throw new Error('http_' + r.status);
                var text = await r.text(), t1 = Date.now();
                var dict = C.parseDict(text);
                mainDicts[lang] = dict;
                var m = { type: 'ready', lang: lang, forms: dict.count, homographs: dict.homo.size, fetchMs: t1 - t0, parseMs: Date.now() - t1 };
                if (readyRes[lang]) { readyRes[lang].res(m); delete readyRes[lang]; }
                if (onMsg) onMsg(m);
            } catch (e) { fail(lang, 'load: ' + e.message); }
        }
        function ensure(lang) {
            if (readyP[lang]) return readyP[lang];
            readyP[lang] = new Promise(function (res, rej) { readyRes[lang] = { res: res, rej: rej }; });
            readyP[lang].catch(function () {});
            if (!w && !useMain) start();
            if (useMain) mainLoad(lang);
            else w.postMessage({ cmd: 'load', lang: lang, url: CFG.dict[lang].url, total: CFG.dict[lang].bytes });
            return readyP[lang];
        }
        function call(msg) {
            if (useMain) {
                var d = mainDicts[msg.lang];
                if (!d) return Promise.reject(new Error('not_loaded'));
                try {
                    if (msg.cmd === 'analyze') return Promise.resolve({ tokens: C.analyze(d, msg.text) });
                    var st = { words: 0, homo: 0, guess: 0, none: 0, marked: 0 };
                    var offs = msg.texts.map(function (tx) {
                        var toks = C.analyze(d, tx);
                        toks.forEach(function (k) {
                            if (k.t !== 'w' || k.src === 'novowel') return;
                            st.words++; if (k.src === 'homo') st.homo++; else if (k.src === 'guess') st.guess++; else if (k.src === 'none') st.none++;
                        });
                        var o = C.stressOffsets(toks, msg.opts, msg.lang); st.marked += o.length; return o;
                    });
                    return Promise.resolve({ offsets: offs, stats: st });
                } catch (e) { return Promise.reject(e); }
            }
            return new Promise(function (res, rej) {
                var id = ++seq; pending[id] = { res: res, rej: rej };
                msg.id = id; w.postMessage(msg);
            });
        }
        return {
            ensure: ensure,
            reset: function (lang) { delete readyP[lang]; delete readyRes[lang]; },
            analyze: function (lang, text) { return ensure(lang).then(function () { return call({ cmd: 'analyze', lang: lang, text: text }); }); },
            offsets: function (lang, texts, opts) { return ensure(lang).then(function () { return call({ cmd: 'offsets', lang: lang, texts: texts, opts: opts }); }); },
            on: function (fn) { onMsg = fn; }
        };
    })();

    /* ── dictionary status line ──────────────────────────────────────────── */

    var statusText = $('ssStatusText'), loadT0 = 0;
    engine.on(function (m) {
        if (m.lang && m.lang !== state.lang) return;
        if (m.type === 'progress') {
            var pct = m.total ? Math.min(99, Math.round(m.loaded / m.total * 100)) : 0;
            statusText.innerHTML = esc(t('status_loading')) + ' <span class="ss-bar-prog" aria-hidden="true"><i style="width:' + pct + '%"></i></span> ' + pct + '%';
        } else if (m.type === 'ready') {
            root.dataset.dict = 'ready';
            statusText.textContent = t('status_ready', { n: fmtNum(m.forms) });
            if (window.__stage) try { window.__stage('dict_ready', { lang: m.lang }); } catch (e) {}
            feature('dict_ready', { lang: m.lang, ms: Date.now() - loadT0, fetch: m.fetchMs, parse: m.parseMs });
        } else if (m.type === 'error') {
            root.dataset.dict = 'error';
            statusText.innerHTML = esc(t('status_error')) + ' <button type="button" class="ss-retry" id="ssRetry">' + esc(t('retry')) + '</button>';
            var rb = $('ssRetry');
            if (rb) rb.onclick = function () { engine.reset(state.lang); startDict(); schedule(0); };
            feature('dict_error', { lang: m.lang, err: String(m.message || '').slice(0, 80) });
        }
    });
    function startDict() {
        root.dataset.dict = 'loading';
        statusText.textContent = t('status_loading');
        loadT0 = Date.now();
        engine.ensure(state.lang).then(function (m) {
            if (m && m.lang === state.lang) { root.dataset.dict = 'ready'; statusText.textContent = t('status_ready', { n: fmtNum(m.forms) }); }
        }, function () {});
    }

    /* ── language ────────────────────────────────────────────────────────── */

    var langBtns = root.querySelectorAll('.ss-lang [data-lang]');
    function setLang(lang, why) {
        if (lang !== 'uk' && lang !== 'be') return;
        var changed = lang !== state.lang;
        state.lang = lang;
        langBtns.forEach(function (b) {
            var on = b.dataset.lang === lang;
            b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        input.setAttribute('lang', lang); out.setAttribute('lang', lang);
        if (why === 'user') { state.langLocked = true; save('lang', lang); }
        if (changed || why === 'init') { startDict(); schedule(0); }
        if (changed) feature('lang', { lang: lang, why: why });
    }
    langBtns.forEach(function (b) { b.addEventListener('click', function () { setLang(b.dataset.lang, 'user'); showNote(null); }); });

    /* ── notes under the panes ───────────────────────────────────────────── */

    function showNote(html) {
        if (!html) { note.hidden = true; note.innerHTML = ''; return; }
        note.innerHTML = html; note.hidden = false;
    }

    /* ── analysis loop ───────────────────────────────────────────────────── */

    var timer = 0;
    function schedule(delay) {
        clearTimeout(timer);
        if (delay === undefined) delay = input.value.length < 6000 ? 90 : 260;
        timer = setTimeout(run, delay);
    }
    function run() {
        var text = input.value, lang = state.lang, my = ++state.seq;
        updateChrome(text);
        if (!text.trim()) { state.tokens = []; state.text = ''; render(); return; }
        var det = C.detectLang(text);
        if (det === 'ru') {
            showNote(t('note_ru', { url: esc(CFG.ruStressUrl) }));
            feature('lang_ru_detected', {});
        } else if ((det === 'uk' || det === 'be') && det !== lang && !state.langLocked) {
            setLang(det, 'auto');
            showNote(esc(t('note_switched', { lang: LANG_NAME[det] })));
            return;                                            // setLang re-schedules in the new language
        } else if (note.dataset.kind !== 'sticky') {
            showNote(null);
        }
        engine.analyze(lang, text).then(function (m) {
            if (my !== state.seq) return;                      // a newer keystroke won
            state.tokens = m.tokens; state.text = text; state.tokLang = lang;
            if (state.quiz && state.quiz.src === 'text') state.quiz = null;
            render();
            if (!state.firstResult) {
                state.firstResult = true;
                if (window.__aeFunnel) try { window.__aeFunnel('first_result', { lang: lang, chars: text.length }); } catch (e) {}
            }
        }, function () {});
    }

    function updateChrome(text) {
        var has = !!text.trim();
        $('ssClear').hidden = !has;
        $('ssCopy').disabled = !has; $('ssDownload').disabled = !has; $('ssPrint').disabled = !has; $('ssShare').disabled = !has;
        var words = has ? (text.match(/[A-Za-zА-Яа-яЁёЄєІіЇїҐґЎў'’ʼ́+-]+/g) || []).length : 0;
        $('ssCount').textContent = words ? t('words', { n: fmtNum(words) }) : '';
    }

    /* ── rendering ───────────────────────────────────────────────────────── */

    function marked(tok, fmt, force) {
        var base = tok.base;
        if (!(force || C.shouldMark(tok, state.opts)) || !tok.stress) return esc(base);
        var set = {}; tok.stress.forEach(function (s) { set[s] = 1; });
        var allCaps = base.length > 1 && base === base.toUpperCase(), s = '';
        for (var j = 0; j < base.length; j++) {
            var ch = base[j];
            s += set[j] ? '<b>' + esc(C.markChar(ch, fmt, allCaps)) + '</b>' : esc(ch);
        }
        return s;
    }
    function wordClass(tok) {
        switch (tok.src) {
            case 'homo': return 'w homo' + (tok.rule ? ' ctx' : '');
            case 'guess': return state.opts.guesses === false ? 'w none' : 'w guess';
            case 'none': return 'w none';
            case 'manual': return 'w man';
            default: return 'w';
        }
    }

    function render() {
        if (state.view === 'quiz') return renderQuiz();
        var toks = state.tokens;
        if (!input.value.trim()) return renderEmpty();
        var one = singleWord();
        if (one >= 0) return renderOne(one);
        var html = [], words = 0, homo = 0, check = 0, cut = false;
        for (var i = 0; i < toks.length; i++) {
            var k = toks[i];
            if (k.t !== 'w') { if (!cut) html.push(esc(k.text)); continue; }
            if (k.src === 'homo') homo++;
            else if ((k.src === 'guess' && state.opts.guesses !== false) || k.src === 'none') check++;
            if (cut) continue;
            if (++words > RENDER_WORDS) { cut = true; continue; }
            var tab = (k.src === 'homo' || k.src === 'guess' || k.src === 'none') ? ' tabindex="0"' : '';
            html.push('<span class="' + wordClass(k) + '" data-i="' + i + '"' + tab + '>' + marked(k, state.fmt) + '</span>');
        }
        out.innerHTML = html.join('');
        if (cut) { showNote(esc(t('note_truncated', { n: fmtNum(RENDER_WORDS) }))); note.dataset.kind = 'sticky'; }
        else if (note.dataset.kind === 'sticky') { note.dataset.kind = ''; showNote(null); }
        chip($('ssChipHomo'), homo);
        chip($('ssChipCheck'), check);
        if (state.flashAt >= 0) {
            var fl = out.querySelector('[data-i="' + tokenAt(state.flashAt) + '"]');
            if (fl) { fl.classList.add('flash'); fl.scrollIntoView({ block: 'nearest' }); }
            state.flashAt = -1;
        }
    }
    // One word typed («випадок», «наголос у слові разом»): the answer IS the view —
    // big word, syllables, meanings — instead of a line with one coloured letter.
    function singleWord() {
        var v = input.value.trim();
        if (v.length > 40 || /\n/.test(v)) return -1;
        var idx = -1;
        for (var i = 0; i < state.tokens.length; i++) {
            var k = state.tokens[i];
            if (k.t !== 'w' || k.src === 'novowel') continue;
            if (idx >= 0) return -1;
            idx = i;
        }
        return idx;
    }
    function renderOne(i) {
        var info = wordInfo(i), tok = info.tok;
        state.cardIdx = i;
        out.innerHTML = '<div class="ss-one" dir="' + PAGE_DIR + '">' +
            '<div class="ss-one-word" dir="ltr">' + info.word + '</div>' +
            (info.syl ? '<p class="ss-card-syl">' + info.syl + '</p>' : '') +
            '<p class="ss-card-src' + (info.cls ? ' ' + info.cls : '') + '"><i></i><span>' + esc(info.msg) + '</span></p>' +
            (info.reads ? '<p class="ss-card-h">' + esc(t('card_readings')) + '</p><div class="ss-reads">' + info.reads + '</div>' : '') +
            (info.vi.length > 1 ? '<p class="ss-card-h">' + esc(t('card_set')) + '</p><div class="ss-vow-word" dir="ltr">' + info.vows + '</div>' : '') +
            '<div class="ss-card-foot"><a class="tc-btn ghost sm" href="' + esc(info.wiki) + '" target="_blank" rel="noopener" title="' + esc(t('card_wiki_title')) + '">' + esc(t('card_wiki')) + ' ↗</a>' +
            (tok.src === 'manual' ? '<button type="button" class="tc-btn ghost sm" data-clear="1">' + esc(t('card_clear')) + '</button>' : '') +
            '</div></div>';
        chip($('ssChipHomo'), 0); chip($('ssChipCheck'), 0);
        if (state.flashAt >= 0) { state.flashAt = -1; out.querySelector('.ss-one-word').classList.add('flash'); }
    }
    function chip(el, n) { el.hidden = !n; el.querySelector('b').textContent = fmtNum(n); }
    function tokenAt(pos) {
        for (var i = 0; i < state.tokens.length; i++) {
            var k = state.tokens[i];
            if (k.t === 'w' && k.start <= pos && pos < k.end) return i;
        }
        return -1;
    }

    function renderEmpty() {
        chip($('ssChipHomo'), 0); chip($('ssChipCheck'), 0);
        out.innerHTML = '<div class="ss-empty" dir="' + PAGE_DIR + '"><p class="ss-empty-t">' + esc(t('empty_title')) + '</p>' +
            '<span>' + esc(t('empty_body')) + '</span><span>' + esc(t('empty_try')) + '</span>' +
            '<div class="tc-chips">' +
            '<button type="button" class="tc-chip" data-ex="uk">' + esc(t('ex_uk')) + '</button>' +
            '<button type="button" class="tc-chip" data-ex="be">' + esc(t('ex_be')) + '</button>' +
            '<button type="button" class="tc-chip" data-ex="homo">' + esc(t('ex_homo')) + '</button>' +
            '</div></div>';
    }

    /* ── word card ───────────────────────────────────────────────────────── */

    var anchorOk = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('anchor-name', '--a');
    var popoverOk = typeof card.showPopover === 'function';
    var anchoredEl = null;

    function prevWord(i) {
        for (var j = i - 1; j >= 0; j--) if (state.tokens[j].t === 'w') return state.tokens[j].base;
        return '';
    }
    function featLabel(f) {
        if (!f) return '';
        var parts = [];
        for (var i = 0; i + 1 < f.length; i += 2) {
            var c = CFG['case'][f[i]], n = CFG['case'][f[i + 1]];
            if (c && n) parts.push(c + ' ' + n);
        }
        return parts.slice(0, 4).join(', ');
    }
    // Wiktionary merges entries, so a common noun can carry «name» from a
    // homonymous place name; show «name» only when it is the whole story.
    function posLabel(p) {
        if (!p) return '';
        var parts = p.split(',');
        if (parts.length > 1) parts = parts.filter(function (x) { return x !== 'name'; });
        return parts.map(function (x) { return CFG.pos[x] || ''; }).filter(Boolean).slice(0, 2).join(', ');
    }
    function stressIdx(tok) { return tok.stress && tok.stress.length ? tok.stress : []; }
    function sameStress(a, b) { return a.length === b.length && a.every(function (x, k) { return x === b[k]; }); }

    // Everything the card (and the single-word view) says about one token.
    function wordInfo(i) {
        var tok = state.tokens[i], lang = state.tokLang || state.lang;
        var vi = C.vowelIdx(lang, tok.base), info = { tok: tok, vi: vi };
        info.word = marked(tok, 'acute', true);
        var syl = C.syllables(lang, tok.base), sylHtml = '';
        var sNo = tok.stress && tok.stress.length ? C.syllableNo(lang, tok.base, tok.stress[0]) : 0;
        syl.forEach(function (x, k) { sylHtml += '<span class="s' + (k + 1 === sNo ? ' on' : '') + '">' + esc(x) + '</span>'; });
        info.syl = vi.length ? '<span dir="ltr">' + sylHtml + '</span>' + (vi.length > 1 && sNo ? ' ' + esc(t('card_syll', { n: sNo, total: vi.length })) : '') : '';
        info.cls = '';
        if (tok.src === 'homo') { info.cls = 'homo'; info.msg = t('src_homo') + ' ' + (tok.rule ? t('rule_' + tok.rule, { w: prevWord(i) }) : t('rule_none')); }
        else if (tok.src === 'guess') { info.cls = 'guess'; info.msg = t('src_guess'); }
        else if (tok.src === 'none') { info.cls = 'none'; info.msg = t('src_none'); }
        else if (tok.src === 'manual') { info.cls = 'man'; info.msg = t('src_manual'); }
        else if (tok.src === 'mono') info.msg = t('src_mono');
        else if (tok.src === 'novowel') { info.cls = 'none'; info.msg = t('src_novowel'); }
        else info.msg = t('src_dict');
        var reads = tok.readings && tok.readings.length > 1 ? tok.readings : null;
        info.reads = '';
        if (reads) {
            var cur = stressIdx(tok);
            reads.forEach(function (r, k) {
                var rt = { base: tok.base, stress: r.s, src: 'dict' };
                var meta = [posLabel(r.p), featLabel(r.f)].filter(Boolean).join(' · ');
                if (r.l && r.l !== tok.base.toLowerCase()) meta += (meta ? ' · ' : '') + '← ' + r.l;
                info.reads += '<button type="button" class="ss-read' + (sameStress(r.s, cur) ? ' on' : '') + '" data-r="' + k + '">' +
                    '<span class="ss-read-w" dir="ltr">' + marked(rt, 'acute', true) + '</span>' +
                    '<span class="ss-read-m">' + esc(meta) + '</span></button>';
            });
        }
        var set = {}, h = '';
        stressIdx(tok).forEach(function (x) { set[x] = 1; });
        for (var j = 0; j < tok.base.length; j++) {
            var ch = tok.base[j];
            if (vi.indexOf(j) >= 0) h += '<button type="button" class="ss-vow' + (set[j] ? ' on' : '') + '" data-v="' + j + '" aria-pressed="' + (set[j] ? 'true' : 'false') + '">' + esc(ch) + '</button>';
            else h += '<span class="c">' + esc(ch) + '</span>';
        }
        info.vows = h;
        info.lemma = reads && reads[tok.pick] && reads[tok.pick].l ? reads[tok.pick].l : tok.base.toLowerCase();
        info.wiki = 'https://' + lang + '.wiktionary.org/wiki/' + encodeURIComponent(info.lemma);
        return info;
    }

    function openCard(i, el) {
        var tok = state.tokens[i];
        if (!tok || tok.t !== 'w') return;
        state.cardIdx = i;
        var info = wordInfo(i);
        $('ssCardWord').innerHTML = info.word;
        $('ssCardSyl').innerHTML = info.syl;
        var src = $('ssCardSrc');
        src.className = 'ss-card-src' + (info.cls ? ' ' + info.cls : '');
        src.querySelector('span').textContent = info.msg;
        $('ssCardReads').hidden = !info.reads;
        $('ssCardReadList').innerHTML = info.reads;
        $('ssCardSetBox').hidden = info.vi.length < 2;
        $('ssCardVows').innerHTML = info.vows;
        $('ssCardClear').hidden = tok.src !== 'manual';
        var wiki = $('ssCardWiki');
        wiki.href = info.wiki; wiki.title = t('card_wiki_title');

        // place it
        if (anchoredEl) anchoredEl.style.removeProperty('anchor-name');
        card.classList.remove('anchored');
        card.style.top = card.style.left = '';
        if (anchorOk && el) {
            el.style.setProperty('anchor-name', '--ss-word'); anchoredEl = el;
            card.classList.add('anchored');
        }
        card.dataset.popOpen = 'true';
        if (popoverOk) { try { if (card.matches(':popover-open')) card.hidePopover(); card.dataset.popOpen = 'true'; card.showPopover(); } catch (e) {} }
        if (!anchorOk && el && window.innerWidth > 560) {
            var r = el.getBoundingClientRect(), cw = card.offsetWidth, chh = card.offsetHeight;
            var top = r.bottom + 6; if (top + chh > window.innerHeight - 8) top = Math.max(8, r.top - chh - 6);
            var left = Math.min(Math.max(8, r.left), window.innerWidth - cw - 8);
            card.style.top = top + 'px'; card.style.left = left + 'px';
        }
        out.querySelectorAll('.w.cur').forEach(function (x) { x.classList.remove('cur'); });
        if (el) el.classList.add('cur');
        feature('card', { src: tok.src, rule: tok.rule || '' });
    }
    function closeCard() {
        card.dataset.popOpen = 'false';
        if (popoverOk) { try { card.hidePopover(); } catch (e) {} }
    }
    // Light dismiss (Esc, a tap outside) closes the popover without us: keep the
    // attribute the CSS hides on in step with it.
    card.addEventListener('toggle', function (e) { card.dataset.popOpen = e.newState === 'open' ? 'true' : 'false'; });
    $('ssCardX').addEventListener('click', closeCard);
    if (!popoverOk) {
        document.addEventListener('pointerdown', function (e) {
            if (card.dataset.popOpen === 'true' && !card.contains(e.target) && !(e.target.closest && e.target.closest('.w'))) closeCard();
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCard(); });
    }

    // Write the person's choice into the text box as their own mark.
    function writeStress(i, stress, how) {
        var tok = state.tokens[i];
        if (!tok || state.text !== input.value) return;
        var raw = input.value.slice(tok.start, tok.end);
        var base = C.splitMarks(state.tokLang || state.lang, raw).base, set = {}, nw = '';
        (stress || []).forEach(function (s) { set[s] = 1; });
        for (var j = 0; j < base.length; j++) { nw += base[j]; if (set[j]) nw += C.ACUTE; }
        if (nw === raw) { closeCard(); return; }
        state.flashAt = tok.start;
        replaceRange(tok.start, tok.end, nw);
        closeCard();
        if (window.__announce) try { window.__announce(t('set_done', { w: base })); } catch (e) {}
        feature('set_stress', { how: how, src: tok.src });
    }
    function replaceRange(a, b, str) {
        var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
        if (fine && document.execCommand) {
            var sx = input.scrollTop;
            try {
                input.focus({ preventScroll: true });
                input.setSelectionRange(a, b);
                if (document.execCommand('insertText', false, str)) { input.scrollTop = sx; return; }
            } catch (e) {}
        }
        input.setRangeText(str, a, b, 'end');
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    $('ssCardVows').addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]'); if (!b) return;
        writeStress(state.cardIdx, [+b.dataset.v], 'vowel');
    });
    $('ssCardReadList').addEventListener('click', function (e) {
        var b = e.target.closest('[data-r]'); if (!b) return;
        var tok = state.tokens[state.cardIdx]; if (!tok || !tok.readings) return;
        writeStress(state.cardIdx, tok.readings[+b.dataset.r].s, 'reading');
    });
    $('ssCardClear').addEventListener('click', function () { writeStress(state.cardIdx, [], 'clear'); });

    out.addEventListener('click', function (e) {
        var ex = e.target.closest('[data-ex]');
        if (ex) { useExample(ex.dataset.ex); return; }
        if (state.view === 'quiz') return quizClick(e);
        var one = e.target.closest('.ss-one');
        if (one) {
            var v = e.target.closest('[data-v]'), r = e.target.closest('[data-r]');
            if (v) writeStress(state.cardIdx, [+v.dataset.v], 'one_vowel');
            else if (r) writeStress(state.cardIdx, state.tokens[state.cardIdx].readings[+r.dataset.r].s, 'one_reading');
            else if (e.target.closest('[data-clear]')) writeStress(state.cardIdx, [], 'one_clear');
            return;
        }
        var w = e.target.closest('.w');
        if (w) openCard(+w.dataset.i, w);
    });
    out.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('w')) {
            e.preventDefault(); openCard(+e.target.dataset.i, e.target);
        }
    });

    // Counters jump to the next word of their kind (and open its card).
    function jump(kind) {
        var sel = kind === 'homo' ? '.w.homo' : '.w.guess,.w.none';
        var list = out.querySelectorAll(sel); if (!list.length) return;
        var from = state.cardIdx, next = null;
        for (var k = 0; k < list.length; k++) if (+list[k].dataset.i > from) { next = list[k]; break; }
        if (!next) next = list[0];
        next.scrollIntoView({ block: 'nearest' });
        next.focus({ preventScroll: true });
        openCard(+next.dataset.i, next);
        feature('jump', { kind: kind });
    }
    $('ssChipHomo').addEventListener('click', function () { jump('homo'); });
    $('ssChipCheck').addEventListener('click', function () { jump('check'); });

    // Caret in the text box ↔ the same word in the result.
    document.addEventListener('selectionchange', function () {
        if (document.activeElement !== input || state.view !== 'result' || state.text !== input.value) return;
        var i = tokenAt(input.selectionStart);
        if (i < 0 && input.selectionStart > 0) i = tokenAt(input.selectionStart - 1);
        out.querySelectorAll('.w.cur').forEach(function (x) { x.classList.remove('cur'); });
        if (i < 0) return;
        var el = out.querySelector('[data-i="' + i + '"]');
        if (el) { el.classList.add('cur'); el.scrollIntoView({ block: 'nearest' }); }
    });

    /* ── practice ────────────────────────────────────────────────────────── */

    // Two sources: the person's own text, or a deck of words people often get
    // wrong (js/slavic-accent/decks.js). The deck is the default while the text
    // box is empty, so the tab is never a dead end.
    function quizSource() { return state.quizSrc === 'deck' || !input.value.trim() ? 'deck' : 'text'; }
    function quizTokens() { return quizSource() === 'deck' ? (state.deck ? state.deck.tokens : []) : state.tokens; }
    function quizItems(toks) {
        var items = [], lang = state.lang;
        toks.forEach(function (k, i) {
            if (k.t === 'w' && k.src === 'dict' && k.stress && k.stress.length === 1 && C.vowelIdx(lang, k.base).length >= 2) items.push(i);
        });
        return items;
    }
    var DECK_ROUND = 20;
    function buildDeck() {
        var lang = state.lang, my = ++state.deckSeq;
        out.innerHTML = '<div class="ss-empty" dir="' + PAGE_DIR + '"><span>' + esc(t('status_loading')) + '</span></div>';
        loadScript(CFG.decksUrl, 'SlavicAccentDecks').then(function (D) {
            var list = (D[lang] || []).slice();
            for (var i = list.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), x = list[i]; list[i] = list[j]; list[j] = x; }
            return engine.analyze(lang, list.slice(0, DECK_ROUND).join('   ·   '));
        }).then(function (m) {
            if (my !== state.deckSeq || state.view !== 'quiz') return;
            state.deck = { lang: lang, tokens: m.tokens };
            state.quiz = null;
            renderQuiz();
        }, function () { out.innerHTML = '<div class="ss-empty" dir="' + PAGE_DIR + '"><span>' + esc(t('status_error')) + '</span></div>'; });
    }
    function renderQuiz() {
        var src = quizSource();
        if (src === 'deck' && (!state.deck || state.deck.lang !== state.lang)) { buildDeck(); return; }
        var toks = quizTokens();
        if (!state.quiz || state.quiz.src !== src) {
            var items = quizItems(toks);
            state.quiz = { src: src, items: {}, total: items.length, ok: 0, bad: 0, done: 0 };
            items.forEach(function (i) { state.quiz.items[i] = 0; });
            feature('quiz_start', { n: items.length, src: src, lang: state.lang });
        }
        var q = state.quiz, hasText = !!input.value.trim();
        var seg = '<div class="tc-seg ss-qsrc" role="radiogroup" aria-label="' + esc(t('quiz_src_label')) + '">' +
            '<button type="button" class="tc-seg-b' + (src === 'text' ? ' on' : '') + '" data-qsrc="text" role="radio" aria-checked="' + (src === 'text') + '"' + (hasText ? '' : ' disabled') + '>' + esc(t('quiz_src_text')) + '</button>' +
            '<button type="button" class="tc-seg-b' + (src === 'deck' ? ' on' : '') + '" data-qsrc="deck" role="radio" aria-checked="' + (src === 'deck') + '">' + esc(t('quiz_src_deck')) + '</button></div>';
        var bar = '<div class="ss-quiz-bar" dir="' + PAGE_DIR + '">' + seg + (q.total
            ? '<span class="ss-qscore">' + t('quiz_score', { ok: '<b>' + q.ok + '</b>', total: '<b>' + q.total + '</b>' }) + '</span>' +
              '<button type="button" class="tc-btn ghost sm" data-q="reveal">' + esc(t('quiz_reveal')) + '</button>' +
              '<button type="button" class="tc-btn ghost sm" data-q="again">' + esc(t('quiz_again')) + '</button>' +
              '<span class="ss-qhint">' + esc(t('quiz_intro')) + '</span>'
            : '<span>' + esc(t('quiz_none')) + '</span>') + '</div>';
        var html = [bar], words = 0;
        for (var i = 0; i < toks.length; i++) {
            var k = toks[i];
            if (k.t !== 'w') { html.push(esc(k.text)); continue; }
            if (++words > RENDER_WORDS) break;
            html.push(i in q.items ? quizWord(k, i, q.items[i]) : esc(k.base));
        }
        out.innerHTML = html.join('');
        out.classList.toggle('deck', src === 'deck');
        chip($('ssChipHomo'), 0); chip($('ssChipCheck'), 0);
    }
    // status: 0 open · 1 right · -1-v wrong (v = picked vowel) · 2 revealed
    function quizWord(k, i, st) {
        var vi = C.vowelIdx(state.lang, k.base), s = '', right = k.stress[0];
        var cls = st === 1 || st === 2 ? 'q ok' : (st < 0 ? 'q bad' : 'q');
        for (var j = 0; j < k.base.length; j++) {
            var ch = esc(k.base[j]);
            if (st === 0 && vi.indexOf(j) >= 0) s += '<span class="v" data-v="' + j + '" role="button" tabindex="0">' + ch + '</span>';
            else if (st !== 0 && j === right) s += '<b>' + esc(C.markChar(k.base[j], 'acute', false)) + '</b>';
            else if (st < 0 && j === -st - 1) s += '<span class="v miss">' + ch + '</span>';
            else s += ch;
        }
        return '<span class="' + cls + '" data-i="' + i + '">' + s + '</span>';
    }
    function quizClick(e) {
        var q = state.quiz; if (!q) return;
        var qs = e.target.closest('[data-qsrc]');
        if (qs) {
            if (qs.disabled) return;
            state.quizSrc = qs.dataset.qsrc; state.quiz = null;
            if (state.quizSrc === 'deck') state.deck = null;
            feature('quiz_src', { src: state.quizSrc });
            renderQuiz(); return;
        }
        var btn = e.target.closest('[data-q]');
        if (btn) {
            if (btn.dataset.q === 'again') {
                state.quiz = null;
                if (q.src === 'deck') state.deck = null;
                feature('quiz_again', { src: q.src });
            } else {
                Object.keys(q.items).forEach(function (i) { if (q.items[i] === 0) q.items[i] = 2; });
                feature('quiz_reveal', { ok: q.ok, bad: q.bad, total: q.total, src: q.src });
            }
            renderQuiz(); return;
        }
        var v = e.target.closest('.v[data-v]'); if (!v) return;
        var span = v.closest('.q'), i = +span.dataset.i;
        if (q.items[i] !== 0) return;
        var tok = quizTokens()[i], pick = +v.dataset.v, ok = pick === tok.stress[0];
        q.items[i] = ok ? 1 : -(pick + 1);
        if (ok) q.ok++; else q.bad++;
        q.done++;
        span.outerHTML = quizWord(tok, i, q.items[i]);
        var sc = out.querySelector('.ss-qscore');
        if (sc) sc.innerHTML = t('quiz_score', { ok: '<b>' + q.ok + '</b>', total: '<b>' + q.total + '</b>' });
        if (window.__announce) try { window.__announce(ok ? t('quiz_ok') : t('quiz_bad')); } catch (x) {}
        if (q.done === q.total) {
            if (window.__toast) window.__toast(t('quiz_done', { ok: q.ok, total: q.total }), 'success');
            feature('quiz_done', { ok: q.ok, total: q.total, lang: state.lang, src: q.src });
            try { if (window.__aeToolComplete) window.__aeToolComplete({ action: 'practice', src: q.src, lang: state.lang, ok: q.ok, total: q.total }); } catch (x) {}
        }
    }
    out.addEventListener('keydown', function (e) {
        if (state.view === 'quiz' && (e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('v')) {
            e.preventDefault(); quizClick({ target: e.target });
        }
    });

    var viewBtns = root.querySelectorAll('.ss-view [data-view]');
    function setView(v) {
        state.view = v; root.dataset.view = v;
        viewBtns.forEach(function (b) { var on = b.dataset.view === v; b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        closeCard();
        var go = function () { render(); };
        if (window.__viewTransition) window.__viewTransition(go); else go();
    }
    viewBtns.forEach(function (b) { b.addEventListener('click', function () { if (b.dataset.view !== state.view) setView(b.dataset.view); }); });

    /* ── mode: text | document ───────────────────────────────────────────── */

    var modeBtns = root.querySelectorAll('.ss-mode [data-mode]');
    function setMode(m) {
        modeBtns.forEach(function (b) { var on = b.dataset.mode === m; b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        $('ssTextMode').hidden = m !== 'text';
        $('ssDocMode').hidden = m !== 'doc';
        root.dataset.mode = m;
        closeCard();
        if (m === 'doc') feature('mode_doc', {});
    }
    modeBtns.forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.mode); }); });

    /* ── settings ────────────────────────────────────────────────────────── */

    var fmtBtns = root.querySelectorAll('.ss-fmt [data-fmt]');
    function setFmt(f, user) {
        state.fmt = f;
        fmtBtns.forEach(function (b) { var on = b.dataset.fmt === f; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        $('ssFmtHint').textContent = t('fmt_' + f + '_hint');
        if (user) { save('fmt', f); feature('format', { fmt: f }); render(); }
    }
    fmtBtns.forEach(function (b) { b.addEventListener('click', function () { setFmt(b.dataset.fmt, true); }); });

    function bindOpt(id, key, store) {
        var el = $(id);
        el.checked = !!state.opts[key];
        el.addEventListener('change', function () {
            state.opts[key] = el.checked; save(store, el.checked);
            feature('option', { k: store, on: el.checked ? 1 : 0 });
            state.quiz = null; render();
        });
    }
    bindOpt('ssOptGuess', 'guesses', 'guesses');
    bindOpt('ssOptMono', 'mono', 'mono');
    bindOpt('ssOptHomo', 'onlyAmbiguous', 'onlyHomo');

    /* ── input ───────────────────────────────────────────────────────────── */

    input.addEventListener('input', function () {
        if (!input.value.trim()) { state.langLocked = false; state.file = null; showNote(null); note.dataset.kind = ''; }
        schedule();
    });
    // The two panes scroll together, so a long text stays side by side.
    var syncing = false;
    input.addEventListener('scroll', function () {
        if (syncing || state.view !== 'result') return;
        var max = input.scrollHeight - input.clientHeight, omax = out.scrollHeight - out.clientHeight;
        if (max <= 0 || omax <= 0) return;
        syncing = true; out.scrollTop = input.scrollTop / max * omax;
        requestAnimationFrame(function () { syncing = false; });
    }, { passive: true });

    function useExample(k) {
        var txt = CFG.examples[k]; if (!txt) return;
        input.value = txt;
        state.langLocked = false;
        if (k === 'be') setLang('be', 'example'); else setLang('uk', 'example');
        schedule(0);
        feature('example', { k: k });
    }

    $('ssClear').addEventListener('click', function () {
        input.value = ''; state.langLocked = false; state.file = null; closeCard();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
    });
    var paste = $('ssPaste');
    if (navigator.clipboard && navigator.clipboard.readText) {
        paste.hidden = false;
        paste.addEventListener('click', function () {
            navigator.clipboard.readText().then(function (txt) {
                if (!txt) return;
                input.focus();
                if (!document.execCommand || !document.execCommand('insertText', false, txt)) {
                    input.setRangeText(txt, input.selectionStart, input.selectionEnd, 'end');
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
                feature('paste', {});
            }, function () { input.focus(); });
        });
    }

    /* ── output: copy · download · share · print ─────────────────────────── */

    function fullText() {
        return C.render(state.tokens, { format: state.fmt, mono: state.opts.mono, guesses: state.opts.guesses, onlyAmbiguous: state.opts.onlyAmbiguous });
    }
    function ready() { return state.text === input.value && state.tokens.length; }
    function complete(action) {
        var st = { words: 0, homo: 0 };
        state.tokens.forEach(function (k) { if (k.t === 'w') { st.words++; if (k.src === 'homo') st.homo++; } });
        try { if (window.__aeToolComplete) window.__aeToolComplete({ action: action, lang: state.lang, fmt: state.fmt, words: st.words, homo: st.homo }); } catch (e) {}
    }
    var copyBtn = $('ssCopy');
    copyBtn.addEventListener('click', function () {
        if (!ready()) return;
        var txt = fullText(), lab = copyBtn.querySelector('span');
        var done = function () {
            lab.textContent = t('copied');
            setTimeout(function () { lab.textContent = t('copy'); }, 1600);
            complete('copy');
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, fallbackCopy);
        else fallbackCopy();
        function fallbackCopy() {
            var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', '');
            ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
            ta.remove();
        }
    });
    function outName(name, lang, ext) {
        var stem = (name || 'text').replace(/\.[^.]+$/, '');
        var n = stem + ' (' + SUFFIX[lang] + ').' + ext;
        try { if (window.__outputName && window.__outputName.sanitize) n = window.__outputName.sanitize(n); } catch (e) {}
        return n;
    }
    $('ssDownload').addEventListener('click', function () {
        if (!ready()) return;
        var ext = state.file ? state.file.ext : 'txt';
        var mime = ext === 'vtt' ? 'text/vtt' : (ext === 'srt' ? 'application/x-subrip' : (ext === 'md' ? 'text/markdown' : 'text/plain'));
        var blob = new Blob([fullText()], { type: mime + ';charset=utf-8' });
        var name = outName(state.file ? state.file.name : 'text', state.lang, ext);
        if (window.__downloadFile) window.__downloadFile(blob, name);
        complete('download');
    });
    var share = $('ssShare');
    if (navigator.share && window.matchMedia && window.matchMedia('(pointer:coarse)').matches) {
        share.hidden = false;
        share.addEventListener('click', function () {
            if (!ready()) return;
            navigator.share({ text: fullText() }).then(function () { complete('share'); }, function () {});
        });
    }
    // The bare mark, for people who type it by hand in Word or a messenger
    // («знак наголосу скопіювати» is a search of its own).
    var markBtn = $('ssCopyMark');
    markBtn.addEventListener('click', function () {
        var done = function () {
            var was = markBtn.textContent; markBtn.textContent = t('copied');
            setTimeout(function () { markBtn.textContent = was; }, 1400);
            feature('copy_mark', {});
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(C.ACUTE).then(done, function () {});
    });
    $('ssPrint').addEventListener('click', function () {
        if (!ready()) return;
        if (state.view !== 'result') setView('result');
        closeCard();
        complete('print');
        setTimeout(function () { window.print(); }, 50);
    });

    /* ── files ───────────────────────────────────────────────────────────── */

    var docState = $('ssDocState'), docAgain = $('ssDocAgain');
    function docMsg(text, kind) {
        docState.hidden = !text; docState.textContent = text || '';
        docState.className = 'ss-doc-state' + (kind ? ' ' + kind : '');
    }
    var _scripts = {};
    function loadScript(url, globalName) {
        if (window[globalName]) return Promise.resolve(window[globalName]);
        if (_scripts[url]) return _scripts[url];
        _scripts[url] = new Promise(function (res, rej) {
            var s = document.createElement('script');
            s.src = url;
            s.onload = function () { window[globalName] ? res(window[globalName]) : rej(new Error('missing ' + globalName)); };
            s.onerror = function () { delete _scripts[url]; rej(new Error('load_failed')); };
            document.head.appendChild(s);
        });
        return _scripts[url];
    }
    function extOf(name) { var m = /\.([a-z0-9]+)$/i.exec(name || ''); return m ? m[1].toLowerCase() : ''; }

    var zone = $('ssDoc');
    if (zone) {
        // Race-safe: a file picked before this deferred script ran is replayed.
        if (typeof window.__bindUploaderFile === 'function') window.__bindUploaderFile(zone, handleFile);
        zone.addEventListener('tool-uploader:clear', function () { docMsg(''); docAgain.hidden = true; });
    }
    function handleFile(f) {
        var ext = extOf(f.name);
        docAgain.hidden = true;
        if (ext === 'docx' || ext === 'odt') return processDoc(f, ext);
        if (['txt', 'text', 'srt', 'vtt', 'md'].indexOf(ext) >= 0) return loadText(f, ext === 'text' ? 'txt' : ext);
        if (ext === 'doc' || ext === 'rtf' || ext === 'pages') docMsg(t('doc_err_format'), 'bad');
        else docMsg(t('doc_err_format'), 'bad');
        feature('doc_reject', { ext: ext });
    }
    async function loadText(f, ext) {
        try {
            var r;
            try { await loadScript(CFG.subtitleParserUrl, 'SubtitleParser'); r = await window.SubtitleParser.readFile(f); }
            catch (e) { r = { text: await f.text(), encoding: 'utf-8' }; }
            input.value = r.text || '';
            state.file = { name: f.name, ext: ext };
            setMode('text');
            state.langLocked = false;
            closeCard();
            schedule(0);
            showNote(esc(t('note_loaded', { name: f.name })));
            feature('text_file', { ext: ext, enc: r.encoding || '', bytes: f.size });
        } catch (e) { docMsg(t('doc_err_generic'), 'bad'); }
    }
    async function processDoc(f, ext) {
        var tk = null;
        if (window.__toolLimit) {
            tk = await window.__toolLimit.begin(CFG.slug, [f.name + ':' + f.size + ':' + f.lastModified]);
            if (!tk) return;
        }
        var fail = function (key, code) {
            if (tk) { try { tk.abort(); } catch (e) {} tk = null; }
            docMsg(t(key), 'bad');
            feature('doc_fail', { ext: ext, code: code });
        };
        try {
            docMsg(t('doc_working', { name: f.name }), '');
            if (window.__stage) try { window.__stage('doc_start', { ext: ext }); } catch (e) {}
            var JSZip = await loadScript(CFG.jszipUrl, 'JSZip');
            var doc = await window.SlavicAccentDoc.read(f, JSZip);
            var sample = doc.texts.join('\n');
            if (!/[А-Яа-яЄєІіЇїҐґЎў]/.test(sample)) return fail('doc_err_empty', 'empty');
            var det = C.detectLang(sample.slice(0, 20000));
            if (det === 'ru') return fail('doc_err_ru', 'ru');
            var lang = det === 'uk' || det === 'be' ? det : state.lang;
            var res = await engine.offsets(lang, doc.texts, state.opts);
            if (!res.stats.marked) return fail('doc_err_empty', 'nomarks');
            var blob = await window.SlavicAccentDoc.write(doc, res.offsets, state.fmt);
            var name = outName(f.name, lang, ext);
            state.lastDoc = { blob: blob, name: name };
            if (window.__downloadFile) await window.__downloadFile(blob, name);
            if (tk) { tk.commit(); tk = null; }
            docMsg(t('doc_done', { marked: fmtNum(res.stats.marked), homo: fmtNum(res.stats.homo) }), 'good');
            docAgain.hidden = false;
            try { if (window.__aeToolComplete) window.__aeToolComplete({ action: 'document', ext: ext, lang: lang, fmt: state.fmt, marked: res.stats.marked, homo: res.stats.homo, words: res.stats.words, bytes: f.size }); } catch (e) {}
        } catch (e) {
            var code = e && e.code;
            fail(code === 'format' ? 'doc_err_format' : (code === 'corrupt' ? 'doc_err_corrupt' : 'doc_err_generic'), code || String(e && e.message || e).slice(0, 60));
        }
    }
    docAgain.addEventListener('click', function () {
        if (state.lastDoc && window.__downloadFile) window.__downloadFile(state.lastDoc.blob, state.lastDoc.name);
    });

    /* ── start ───────────────────────────────────────────────────────────── */

    setFmt(state.fmt, false);
    setLang(state.lang, 'init');
    render();
})();
